// Lightweight GA4 helpers (gtag is loaded in public/index.html).
export function track(eventName, params = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
}

export function trackBotClick(botName, botUrl) {
  track("bot_click", {
    bot_name: botName,
    bot_url: botUrl,
    event_category: "engagement",
  });
}

export function trackRequestBuildClick(location, tier) {
  track("request_build_click", {
    event_category: "conversion",
    location: location || "unknown",
    tier: tier || "general",
  });
}

export function trackEarlyAccessClick() {
  track("early_access_click", { event_category: "conversion" });
}
